module.exports = __webpack_public_path__ + "static/media/Partner-LogosBriP.aaefa0d1.png";